import { Spinner, SpinnerProps } from "react-bootstrap";

interface IProps extends SpinnerProps {
    isHidden?: boolean;
    className?: string;
    small?: boolean;
    message?: string | React.ReactNode;
    style?: React.CSSProperties;
}

const LobbieSpinner: React.FC<IProps> = ({
    animation,
    isHidden,
    className,
    small,
    message,
    style,
}) => (
    <>
        <Spinner
            animation={animation ?? "border"}
            size={small ? "sm" : undefined}
            style={style}
            className={`${className ? "my-2 " + className : "my-2"} blue ${
                isHidden ? "invisible" : ""
            }`}
        />
        {message && (
            <div className={`ml-1 blue body-small ${isHidden ? "invisible" : ""}`}>{message}</div>
        )}
    </>
);

export default LobbieSpinner;
